import type { IconAsset } from '../Icon.types';

const code = (
  <g transform='translate(-17 -35)'>
    <rect
      fill='currentColor'
      height='2'
      transform='translate(21 41)'
      width='16'
    />
    <rect
      fill='currentColor'
      height='2'
      transform='translate(21 46)'
      width='16'
    />
    <rect
      fill='currentColor'
      height='2'
      transform='translate(21 51)'
      width='16'
    />
  </g>
);

export const burgerMenu: IconAsset = {
  regular: {
    l: {
      code,
    },
    m: {
      code,
    },
    s: {
      code,
    },
  },
};
